import { NavigationTranslationType, ProfileTranslationType, ErrorsTranslationType, CommonTranslationType } from "../../features/types";

// Remove nested structure type and export a flatter object structure
export const common = {
  navigation: {
    dashboard: "Dashboard",
    profile: "Profil",
    signOut: "Abmelden"
  },
  profile: {
    title: "Profil",
    dangerZone: "Gefahrenzone",
    deleteAccount: "Konto Löschen",
    confirmDelete: "Löschen Bestätigen",
    deleteWarning: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    confirmDeleteButton: "Konto Löschen",
    accountDeleted: "Konto Gelöscht",
    accountDeletedMessage: "Ihr Konto wurde erfolgreich gelöscht."
  },
  cancel: "Abbrechen",
  delete: "Löschen",
  deleteConfirmation: "Löschen Bestätigen",
  deleteConfirmationMessage: "Sind Sie sicher, dass Sie löschen möchten",
  confirm: "Bestätigen",
  errors: {
    error: "Fehler",
    notFound: "Seite nicht gefunden",
    deleteAccountError: "Beim Löschen Ihres Kontos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    loadStoryError: "Fehler beim Laden der Geschichte. Bitte versuchen Sie es erneut.",
    loadCharactersError: "Fehler beim Laden der Charaktere. Bitte versuchen Sie es erneut.",
    summaryError: "Fehler beim Generieren der Zusammenfassung. Bitte versuchen Sie es erneut."
  }
};
